var map = {
	"./contact/index.vue": [
		"0648",
		"chunk-230c3c54"
	],
	"./index/index.vue": [
		"37f9",
		"chunk-fd140784"
	],
	"./layouts/main.vue": [
		"5658",
		"chunk-4baff929"
	],
	"./terms/privacy-policy.vue": [
		"45f7",
		"chunk-6c4d7ad9"
	],
	"./terms/terms-of-use.vue": [
		"ab35",
		"chunk-79685cf4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;